module.exports = __webpack_public_path__ + "static/media/icon_cross.3aa27564.svg";